import React from "react";
import { AlertTriangle, RotateCw } from "lucide-react";
import { useI18n } from "../../i18n";
import { estErreurDeChargement } from "../../lib/chargementDiffere";

// Écran affiché à la place d'un écran blanc. Composant fonction à part : la
// classe ci-dessous ne peut pas appeler le hook useI18n, lui si.
function EcranErreur({ chargement, pleinePage }) {
  const { t } = useI18n();
  const Titre = pleinePage ? "h1" : "h2";
  return (
    <div
      role="alert"
      data-testid="erreur-chargement"
      className={
        pleinePage
          ? "min-h-screen flex items-center justify-center px-4"
          : "flex items-center justify-center px-4 py-16"
      }
      style={pleinePage ? { background: "var(--trm-bg)" } : undefined}
    >
      <div className="trm-card max-w-sm w-full p-8 text-center">
        <AlertTriangle
          aria-hidden="true"
          className="h-7 w-7 mx-auto mb-4"
          style={{ color: "var(--trm-warn)" }}
        />
        <Titre className="font-semibold text-base mb-2" style={{ color: "var(--trm-ink)" }}>
          {t(chargement ? "common.load_failed_title" : "common.crash_title")}
        </Titre>
        <p className="text-sm mb-6" style={{ color: "var(--trm-muted)" }}>
          {t(chargement ? "common.load_failed_body" : "common.crash_body")}
        </p>
        <button
          type="button"
          className="btn btn-primary w-full"
          onClick={() => window.location.reload()}
        >
          <RotateCw aria-hidden="true" className="h-4 w-4" />
          {t("common.reload")}
        </button>
      </div>
    </div>
  );
}

/**
 * Limite d'erreur posée autour des Suspense : si un morceau de code ne se
 * charge pas (ou si une page plante à l'affichage), on propose « Recharger »
 * au lieu d'un écran blanc. Le rechargement automatique unique est tenté en
 * amont, dans lazyAvecRecharge (lib/chargementDiffere.js).
 *
 *   cleReinit  : quand elle change (ex. l'adresse de la page), l'erreur est
 *                oubliée et on retente l'affichage — naviguer ailleurs depuis
 *                la barre latérale ne reste pas bloqué sur cet écran.
 *   pleinePage : l'écran d'erreur occupe toute la fenêtre.
 */
export default class LimiteErreurChargement extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidUpdate(propsPrecedentes, etatPrecedent) {
    // etatPrecedent.erreur : l'erreur était déjà affichée AVANT ce changement
    // d'adresse (sinon c'est la nouvelle page elle-même qui vient d'échouer).
    if (
      this.state.erreur &&
      etatPrecedent.erreur &&
      propsPrecedentes.cleReinit !== this.props.cleReinit
    ) {
      this.setState({ erreur: null });
    }
  }

  render() {
    if (this.state.erreur) {
      return (
        <EcranErreur
          chargement={estErreurDeChargement(this.state.erreur)}
          pleinePage={this.props.pleinePage}
        />
      );
    }
    return this.props.children;
  }
}
